import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-profile',
  imports: [
    CardModule,
    ButtonModule,
    CommonModule
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  invoices: {
    date: string,
    status: string,
    total: number,
    fileUrl: string
  }[] = [
      { date: "October 24, 2025", status: "Paid", total: 372, fileUrl: "https://pdfobject.com/pdf/sample.pdf" },
      { date: "October 24, 2025", status: "Failed", total: 372, fileUrl: "https://pdfobject.com/pdf/sample.pdf" }
    ];

  profileImageUrl = '../../../../assets/images/default-profile-img.svg'; // initial image

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.profileImageUrl = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }
}
